/**
 * @generated SignedSource<<869d7c4f4e777c6fd65d1f9e817e1ce1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsWordpressArticlesWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedWordpressArticlesWrapper_viewer">;
  readonly " $fragmentType": "SbRespInteriorsWordpressArticlesWrapper_viewer";
};
export type SbRespInteriorsWordpressArticlesWrapper_viewer$key = {
  readonly " $data"?: SbRespInteriorsWordpressArticlesWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsWordpressArticlesWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsWordpressArticlesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedWordpressArticlesWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d3b28eea60ed9f75fec5509c8ab252a5";

export default node;
